import React from "react";

const NewGif = () => {
  return (
    <img
      src="./images/gif/new.gif"
      alt=""
      width={28}
      height={11}
    />
  );
};

export default NewGif;
